import React from 'react'
import Breadcrumbs from '../../components/Breadcrumbs';

function Automotive() {
//   const page = "automotive";
    const page = "industry";
  return (
    <div>
        <section className={`hero ${page}`}>
            <h1>Automotive</h1>
        </section>

        <Breadcrumbs
            items={[
                { label: "Home", to: "/" },
                { label: "Solutions", to: "/solutions" },
                { label: "Automotive" }, // no `to` = current page
        ]}
        />
        
        <section class="split-about">
        <div class="split-about__wrap">
            <div class="split-about__content">
            <p>
                The automotive industry is one of the most safety-critical sectors, requiring materials that can withstand high mechanical stress, extreme heat, and stringent 
                quality controls. Components such as brake linings and friction materials directly affect passenger safety, making performance consistency and durability non-negotiable. 
                As global automotive standards continue to evolve, suppliers must deliver solutions that combine reliability with innovation.
            </p>
            </div>


            <figure class="split-about__media">
            <img src="/assets/images/industry/automotive.png" alt="Automotive" />
            </figure>

        </div>
        </section>

        <section class="applications">
        <div class="applications__wrap">
            <h1>Our Solutions:</h1>

            <ul class="applications__list">
            <li><strong>Additives for Brake & Lining Applications</strong>: Deliver heat resistance, friction stability, and durability.</li>
            <li><strong>Safety & Compliance</strong>: Materials engineered to meet global safety standards.</li>
            <li><strong>Reliability</strong>: Long-lasting performance that reduces replacement cycles.</li>
            </ul>

            <p>
            </p>
        </div>
        </section>        
    </div>
  )
}

export default Automotive